import React from 'react'
import './active-user-section.css'
const ActiveUserSection = ({whosLoggedIn}) => {

    React.useEffect(() => {
        let adminBubbles = document.getElementsByClassName("user-icon-wrapper__image-circle");
        for (let i = 0; i < adminBubbles.length; i++) {
          adminBubbles[i].style.backgroundColor = "#DEE7EE";
          adminBubbles[i].style.display = "none";
        }
        for (let i = 0; i < whosLoggedIn.length; i++) {
          if (whosLoggedIn[i].user === "Bri Massie" || whosLoggedIn[i].user === "Courtney Malloy" || whosLoggedIn[i].user === "Prescott Blackler" || whosLoggedIn[i].user === "Danit Yeshaya" || whosLoggedIn[i].user === "Ella Moseley") {
            setTimeout(() => {
              document.getElementById(`${whosLoggedIn[i].user.replace(/\s/g, "").toLowerCase()}-online-icon-circle`).style.backgroundColor = "green";
              document.getElementById(`${whosLoggedIn[i].user.replace(/\s/g, "").toLowerCase()}-online-icon-circle`).style.display = "inline-block";
            }, 0)

          }
        }
      }, [whosLoggedIn]);

    return(
        <div className="who-is-logged-in__wrapper">
          <div className="user-icon-wrapper__image-circle" id="brimassie-online-icon-circle">
            <img className="user-icon-image" alt="user" src="https://app.atharo.app/brimassie.jpg" />
          </div>
          <div className="user-icon-wrapper__image-circle" id="courtneymalloy-online-icon-circle">
            <img className="user-icon-image" alt="user" src="https://app.atharo.app/courtneymalloy.jpg" />
          </div>
          <div className="user-icon-wrapper__image-circle" id="prescottblackler-online-icon-circle">
            <img className="user-icon-image" alt="user" src="https://app.atharo.app/prescottblackler.jpg" />
          </div>
          <div className="user-icon-wrapper__image-circle" id="danityeshaya-online-icon-circle">
            <img className="user-icon-image" alt="user" src="https://app.atharo.app/danityeshaya.jpg" />
          </div>
          <div className="user-icon-wrapper__image-circle" id="ellamoseley-online-icon-circle">
            <img className="user-icon-image" alt="user" src="https://app.atharo.app/ellamoseley.jpg" />
          </div>
        </div>
    )
}
export default ActiveUserSection